import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isPresent } from '@shared/utils/helpers';
import { roundToNearest } from '@shared/utils/math';
import { round } from 'lodash-es';

@Pipe({ name: 'appHours' })
export class HoursPipe implements PipeTransform {
    transform(value: number, roundValue: boolean | number = true): any {
        if (!isPresent(value)) {
            return value;
        }

        if (isNaN(value)) {
            return value;
        }

        if (roundValue === true) {
            return `${roundToNearest(value / 3600, .25)}h`;
        }

        if (typeof roundValue === 'number') {
            return `${round(value / 3600, roundValue)}h`;
        }

        return `${value / 3600}h`;
    }
}
